<button mat-raised-button color="primary" (click)="logFormValue()">Log form's value</button>
<div *ngIf="form">
   <h2>From errors {{ form.errors | json }}</h2>
   <ul>
      <li *ngFor="let control of Object.keys(form.controls)">
         {{ control }} -- {{ form.controls[control].errors | json }}
      </li>
   </ul>
</div>
